import CommonState from '../parameters/CommonState'

export class AdvancedSearchConsts {
  constructor() {
  }
}

export const OPERATOR_EQUAL = new CommonState('=', '等于', 'Equal')
export const OPERATOR_UNEQUAL = new CommonState('!=', '不等于', 'Unequal')
export const OPERATOR_GREATER = new CommonState('>=', '大于', 'Greater')
export const OPERATOR_LESS = new CommonState('<=', '小于', 'Less')
export const OPERATOR_LIKE = new CommonState('LIKE', '包含', 'Like')
export const OPERATOR_IN = new CommonState('IN', '包含', 'In')
export const OPERATOR_NOT_LIKE = new CommonState('NOT LIKE', '不包含', 'Not_Like')
export const OPERATOR_NOT_IN = new CommonState('NOT IN', '不包含', 'Not_In')
export const OPERATOR_IS_NOT_NULL = new CommonState('IS NOT NULL', '不为空', 'Is_Not_Null')
export const OPERATOR_IS_NULL = new CommonState('IS NULL', '为空', 'Is_Null')
export const OPERATOR_IS_IT_EMPTY = new CommonState('IS IT EMPTY', '是否为空', 'Is_It_Empty')
export const OPERATOR_IS_IT_NOT_EMPTY = new CommonState('IS IT NOT EMPTY', '是否不为空', 'Is_It_Not_Empty')
export const OPERATOR_RANGE = new CommonState('RANGE', '范围', 'Range')
export const OPERATOR_BATCH = new CommonState('BATCH', '批量', 'Batch')
export const OPERATOR_BATCH_EXCLUDE = new CommonState('BATCH_EXCLUDE', '不包含', 'BatchExclude')
export const OPERATOR_REGEXP = new CommonState('REGEXP', '批量模糊', 'Regexp')
export const OPERATOR_DATE_ITEM = new CommonState('DATE ITEM', '快捷项', 'Date_Item')
export const OPERATOR_DATE_ITEM_EXTEND = new CommonState('DATE ITEM EXTEND', '快捷项', 'Date_Item') // 扩展快捷项，补充当天选项

/**
 * 字段类型
 */
export const FIELD_TEXT = 'text'
export const FIELD_MULTI_TEXT = 'multiText'
export const FIELD_DROP_DOWN_LIST = 'dropDownList'
export const FIELD_DROP_DOWN_LIST2 = 'dropDownList2'
export const FIELD_MULTI_DROP_DOWN_LIST = 'multiDropDownList'
export const FIELD_MULTI_DROP_DOWN_LIST2 = 'multiDropDownList2'
export const FIELD_DATE = 'date'
export const FIELD_DATE_RANGE = 'dateRange'
export const FIELD_DATE_NODE = 'dateNode'
export const FIELD_AIRPORT = 'airport'
export const FIELD_SEAPORT = 'seaport'
export const FIELD_SEA_DEST_AGENT = 'seaDestAgent'
export const FIELD_LOCAL_AGENT = 'localAgent'
export const FIELD_SEA_DESIGNATION_AGENT = 'seaDesignationAgent'
export const FIELD_BOOKING_AGENT = 'bookingAgent'
export const FIELD_CARRIER_AGENT = 'carrierAgent'
export const FIELD_AIR_COMPANY = 'airCompany'
export const FIELD_CARRIER = 'carrier'
export const FIELD_USER = 'user'
export const FIELD_USER2 = 'user2'
export const FIELD_USER_SEA = 'userSea'
export const ALL_USER_2 = 'allUser2'
export const FIELD_SALES_OF_GOODS = 'salesOfGoods'
export const FIELD_CURRENCY = 'currency'
export const FIELD_MULTI_CURRENCY = 'multiCurrency'
export const FIELD_MULTI_CURRENCY1 = 'multiCurrency1'
export const FIELD_RADIO = 'radio'
export const FIELD_CHECKBOX = 'checkbox'
export const FIELD_BANK_ACCOUNT = 'bankAccount'
export const FIELD_COMPANY = 'company'
export const FIELD_HQ_COMPANY = 'hqCompany'
export const FIELD_SETTLEMENT_AGENT = 'settlementAgent'
// 收货人
export const FIELD_CONSIGNEE = 'consigneeCompany'
// 发货人
export const FIELD_SHIPPER = 'shipperCompany'
export const FIELD_COMPANY_ENGLISH_NAME = 'companyEnglishName'
export const FIELD_CARRYING_CMP = 'carryingCmp'
export const FIELD_CHARGE = 'charge'
export const FIELD_NUMBER_RANGE = 'numberRange'
// 正数范围
export const FIELD_POSITIVE_NUMBER_RANGE = 'numberRange'
export const FIELD_CHAR_RANGE = 'charRange'
export const FIELD_NUMBER = 'number'
export const FIELD_IS_NOT_NULL = 'isNotNull'
export const FIELD_DEPARTMENT = 'department'
export const FIELD_DEPARTMENT2 = 'department2'
export const FIELD_DEPARTMENT3 = 'department3'
export const FIELD_DEPARTMENT4 = 'department4'
export const FIELD_DEPARTMENT5 = 'department5'
export const FIELD_CUSTOMERTYPE = 'customerType'
export const FIELD_CUSTOMERTYPE_MUTI = 'customerTypeMuti'
export const FIELD_CREDITDATETYPE = 'creditDateType'
export const FIELD_CARGOSOURCE = 'cargoSource'
export const FIELD_CUSTOMER = 'customer'
export const FIELD_COUNTRY = 'country'
export const FIELD_RELEASERE_VIEW_STATE = 'releaseReviewState'
export const FIELD_RELEASE_STATE = 'releaseState'
export const FIELD_MULTI_ISSUERBL = 'multiIssuerBL'
export const FIELD_SETTLEMENT_TYPE = 'settlementType'
export const FIELD_TRACKING = 'tracking'
export const FIELD_TRACKING_MULTIPLE = 'trackingMultiple'
export const FIELD_RELEASETYPE = 'releaseType'
export const FIELD_MBL_RELEASETYPE = 'mblReleaseType'
export const FIELD_HBL_RELEASETYPE = 'hblReleaseType'
export const FIELD_CUSTOMCLAIM = 'customClaim'
export const FIELD_CUSTOMSCLAIM2 = 'customsClaim2'
export const FIELD_PAYMENTTERMMBL = 'paymentTermMBL'
export const FIELD_SEND_DATA_STATE = 'releaseSendDataState'
export const FIELD_VESSEL = 'vessel'
export const FIELD_SEA_CARGOTYPE = 'seaCargoType'
export const FIELD_CUSTOMER_BROKER = 'customsBroker'
export const FIELD_WAREHOUSE = 'warehouse'
export const FIELD_CUTOM_JOB_TYPE = 'seJobCutomJobType'
export const FIELD_CUTOM_JOB_TYPE_SI = 'siJobCutomJobType'
export const FIELD_CUTOM_JOB_TYPE_AE = 'aeJobCutomJobType'
export const FIELD_CUTOM_JOB_TYPE_AI = 'aiJobCutomJobType'
export const FIELD_CUTOM_JOB_TYPE_RE = 'reJobCutomJobType'
export const FIELD_CUTOM_JOB_TYPE_ALL = 'allJobCutomJobType'
export const FIELD_FILE_TYPE_ALL = 'allFileType'
export const FIELD_REGION = 'region'
export const FIELD_REGION_MUTI = 'regionMuti'
export const FIELD_DROP_DOWN_LIST_COLLECTION = 'dropListCollection'
export const FIELD_TRADE_METHOD = 'tradeTerm'
// CARGO-7863 操作分公司和销售分公司
export const FIELD_OP_OFFICE = 'opOffice'
export const FIELD_SALES_OFFICE = 'salesOffice'
// CARGO-7975
export const FIELD_IS_NOT_ZERO = 'isNotZero'
// 口岸代理
export const FIELD_PORT_AGENT = 'portAgent'
// FBA报价目的地高级查询
export const FBA_QUOTATION_WAREHOUSE_CODE = 'fbaQuotationWarehouseCode'
// 发运代理
export const FIELD_FORWARDING_AGENT = 'forwardingAgent'
// 装货地公司
export const FIELD_LOADINGPLACE_COMPANY = 'loadingPlaceCompany'
// 签单地公司
export const FIELD_SIGNBILLPLACE_COMPANY = 'signBillPlaceCompany'
// 卸货港公司
export const FIELD_DISCHARGEPORT_COMPANY = 'dischargePortCompany'
// 目的港公司
export const FIELD_DESTINATIONPORT_COMPANY = 'destinationPortCompany'
// 铁路航线（单选）
export const FIELD_TRANSPORTLINE = 'transportLine'
// 铁路航线（多选）
export const FIELD_TRANSPORTLINE2 = 'transportLine2'
// 铁路站点
export const FIELD_RAILWAYSTATION = 'railwayStation'
// 根据权限控制的委托单位控件
export const FIELD_CUSTOMER_ROLE = 'customerByRole'
// CARGO-741，已生成凭证查询界面增加筛选项对方凭证号
export const FIELD_TEXT2 = 'text2'
// CARGO-21216 H5 门店地址查询项只有等于，而flash里这个查询项是包含
export const FIELD_TEXT3 = 'text3'
// CARGO-1427 添加贸易条款查询条件
export const FIELD_TRADETERMS2 = 'tradeTerms2'
// 运输条款
export const FIELD_SHIPPINGTERM = 'shippingTerm'

// CARGO-16260 时贝希定制化服务OMS管理搜索条件-干线业务编号增加为空筛选条件
export const FIELD_TEXT4 = 'text4'
// CARGO-21732 海运订舱筛选条件：HBL分并单号、MBL分并单号增加是否为空模式
export const FIELD_TEXT5 = 'text5'
// CARGO-26061 结算-对账新版-对账界面”业务参考号“筛选条件增加批量检索功能
export const FIELD_MULT_TEXT2 = 'multiText2'
export const FIELD_MULT_TEXT3 = 'multiText3'
export const FIELD_MULT_TEXT4 = 'multiText4'
export const FIELD_MULT_TEXT5 = 'multiText5'
// 客户来源
export const FIELD_CUSTOMER_SOURCE = 'customerSource'
// 运输类型
export const FIELD_TRANSPORT_TYPE = 'transportType'
// 放行配载状态
export const FIELD_RELEASE_STOWAGE_STATE = 'releaseStowageState'
// 海外仓
export const FIELD_OVERSEA_WAREHOUSE = 'overseaWarehouse'
// 增值服务
export const FIELD_VALUE_ADDED_SERVICE = 'valueAddedService'
// 渠道
export const FIELD_FBA_CHANNEL = 'fbaChannel'

// 批量排除
export const FIELD_MULTI_EXCLUDE_TEXT = 'multiTextAndExclude'
// 码头公司
export const FIELD_TERMINAL_COMPANY = 'terminalCompany'
export const FIELD_INCOTERM = 'incoTerm'
// 审核操作人
export const FIELD_AUDIT_OPERATOR = 'auditOperator'
// 目的港国家、卸货港国家
export const FIELD_POD_COUNTRY = 'podCountry'
export const FIELD_TEXT7 = 'text7'

export const FIELD_OPERATOR_MAP = {
  'text': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE],
  'text2': [OPERATOR_EQUAL],
  'text3': [OPERATOR_LIKE],
  'text4': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_IS_NULL],
  'text5': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_IS_IT_EMPTY],
  'text6': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'text7': [OPERATOR_EQUAL, OPERATOR_LIKE],
  // NOTE: REGEXP uses a single string value; UI will assist multi-line input and join with '|'.
  'multiText': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH, OPERATOR_REGEXP],
  'multiText2': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH, OPERATOR_REGEXP, OPERATOR_IS_NULL],
  'multiText3': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH, OPERATOR_REGEXP, OPERATOR_BATCH_EXCLUDE, OPERATOR_IS_NOT_NULL, OPERATOR_IS_NULL],
  'multiText4': [OPERATOR_EQUAL, OPERATOR_LIKE, OPERATOR_BATCH, OPERATOR_REGEXP],
  'multiText5': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH, OPERATOR_REGEXP, OPERATOR_IS_NOT_NULL, OPERATOR_IS_NULL],
  'dropDownList': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'dropDownList2': [OPERATOR_EQUAL],
  'multiDropDownList': [OPERATOR_IN],
  'multiDropDownList2': [OPERATOR_IN, OPERATOR_NOT_IN],
  'date': [OPERATOR_EQUAL, OPERATOR_GREATER, OPERATOR_LESS],
  'dateRange': [OPERATOR_RANGE, OPERATOR_DATE_ITEM, OPERATOR_IS_NOT_NULL, OPERATOR_IS_NULL],
  'dateNode': [OPERATOR_EQUAL],
  'airport': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'seaport': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'overseaWarehouse': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'fbaChannel': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'valueAddedService': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'seaDestAgent': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'bookingAgent': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'carrierAgent': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'airCompany': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'carrier': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'salesOfGoods': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'user': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
  'user2': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_IS_NULL],
  'allUser2': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
  'userSea': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_NOT_IN],
  'currency': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'multiCurrency': [OPERATOR_IN, OPERATOR_NOT_IN],
  'multiCurrency1': [OPERATOR_IN, OPERATOR_NOT_IN],
  'checkbox': [OPERATOR_EQUAL],
  'radio': [OPERATOR_EQUAL],
  'bankAccount': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'company': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'hqCompany': [OPERATOR_IN, OPERATOR_NOT_IN],
  'settlementAgent': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  // 收货人
  'consigneeCompany': [OPERATOR_EQUAL],
  // 发货人
  'shipperCompany': [OPERATOR_EQUAL],
  'companyEnglishName': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'carryingCmp': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'charge': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'numberRange': [OPERATOR_RANGE],
  'charRange': [OPERATOR_RANGE],
  'number': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_GREATER, OPERATOR_LESS],
  'isNotNull': [OPERATOR_EQUAL],
  'department': [OPERATOR_IN],
  'customerType': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'customerTypeMuti': [OPERATOR_IN],
  'creditDateType': [OPERATOR_EQUAL],
  // 目的港国家
  'country': [OPERATOR_EQUAL],
  // 目的港国家、卸货港国家多选
  'podCountry': [OPERATOR_IN, OPERATOR_NOT_IN],
  'cargoSource': [OPERATOR_EQUAL],
  'releaseReviewState': [OPERATOR_EQUAL],
  'releaseState': [OPERATOR_IN],
  'multiIssuerBL': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'settlementType': [OPERATOR_EQUAL],
  'tracking': [OPERATOR_EQUAL],
  'department2': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'department3': [OPERATOR_IN],
  'department4': [OPERATOR_IN],
  'department5': [OPERATOR_IN],
  'releaseType': [OPERATOR_IN],
  'mblReleaseType': [OPERATOR_IN],
  'hblReleaseType': [OPERATOR_IN],
  'vessel': [OPERATOR_EQUAL, OPERATOR_LIKE],
  'releaseSendDataState': [OPERATOR_EQUAL],
  'customsBroker': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'warehouse': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'seJobCutomJobType': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'siJobCutomJobType': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'aeJobCutomJobType': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'aiJobCutomJobType': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'reJobCutomJobType': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'allJobCutomJobType': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'allFileType': [OPERATOR_EQUAL],
  'region': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'regionMuti': [OPERATOR_IN, OPERATOR_UNEQUAL],
  'dropListCollection': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  // CARGO-7863 操作分公司和销售分公司
  'opOffice': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  'salesOffice': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  // CARGO-7975
  'isNotZero': [OPERATOR_EQUAL],
  // CARGO-31618 FBA-报价管理 设置目的地增加【批量】检索条件
  'fbaQuotationWarehouseCode': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN, OPERATOR_BATCH],
  // 口岸代理
  'portAgent': [OPERATOR_EQUAL],
  // 发运代理
  'forwardingAgent': [OPERATOR_EQUAL],
  // 装货地公司
  'loadingPlaceCompany': [OPERATOR_EQUAL],
  // 签单地公司
  'signBillPlaceCompany': [OPERATOR_EQUAL],
  // 卸货港公司
  'dischargePortCompany': [OPERATOR_EQUAL],
  // 目的港公司
  'destinationPortCompany': [OPERATOR_EQUAL],
  // 铁路航线
  'transportLine': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  // 铁路站点
  'railwayStation': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  // 贸易条款
  'tradeTerms2': [OPERATOR_IN],
  // 铁路航线(多选)
  'transportLine2': [OPERATOR_IN, OPERATOR_UNEQUAL],
  // 运输条款
  'shippingTerm': [OPERATOR_IN],
  // 客户来源
  'customerSource': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  // 运输类型
  'transportType': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  // 放行配载状态
  'releaseStowageState': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_IN],
  // 添加批量排除
  'multiTextAndExclude': [OPERATOR_EQUAL, OPERATOR_UNEQUAL, OPERATOR_LIKE, OPERATOR_BATCH, OPERATOR_BATCH_EXCLUDE],
  // 主单运费条款、分单运费条款
  'paymentTermMBL': [OPERATOR_IN],
  // 码头公司
  'terminalCompany': [OPERATOR_EQUAL, OPERATOR_UNEQUAL],
  // 审核操作人
  // 'auditOperator': [OPERATOR_EQUAL, OPERATOR_IN]
  'auditOperator': [OPERATOR_EQUAL]
}
